import { axiosServicesApi } from '@/services/api/deprecated';
import type { ServicesApiCampaign, ServicesApiNewsletter } from '@/services/api/services-api';
import type { SetupGuide } from '.';

export const getSetupGuide = async (environmentId: unknown) => {
  if (Number.isNaN(Number.parseFloat(environmentId as string))) {
    return null;
  }
  const { data } = await axiosServicesApi.get<{ setup_guide: SetupGuide }>(
    `/environments/${environmentId}/setup_guide/current`,
  );
  return data;
};

export const updateSetupGuide = async (environmentId: number, setupGuide: SetupGuide) => {
  await axiosServicesApi.put(`/environments/${environmentId}/setup_guide/current`, { setup_guide: { ...setupGuide } });
};

export const getFirstMessageData = async (
  environmentId: number,
  firstMessageId: number,
  firstMessageType: string,
): Promise<{ campaign?: ServicesApiCampaign; newsletter?: ServicesApiNewsletter }> => {
  const pluralizedType = firstMessageType === 'campaign' ? 'campaigns' : 'newsletters';
  const { data } = await axiosServicesApi.get<{ campaign?: ServicesApiCampaign; newsletter?: ServicesApiNewsletter }>(
    `/environments/${environmentId}/${pluralizedType}/${firstMessageId}`,
  );
  return data;
};
